/* eslint-disable */
import { FC } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { BarWithErrorBarsController, BarWithErrorBar } from 'chartjs-chart-error-bars';
import _ from 'lodash';

import { barChartOptions } from '../../utilities/chartUtils';
import { ChartSkeleton } from '../ChartSkeleton/ChartSkeleton';
import { Title, NoData, FilterSlot } from '../ChartSkeleton/styles';
import { ChartData, ChartOptions, DefaultDataPoint } from 'chart.js';
import { DataPointsPlugin } from '../../chartPlugins/OutliersPlugin';
import { BGPlugin } from '../../chartPlugins/BGPlugin';
import { ClickOnTickPlugin } from '../../chartPlugins/ClickOnTickPlugin';
import { CornerTitlePlugin } from '../../chartPlugins/CornerTitlePlugin';

Chart.register(BarWithErrorBarsController, BarWithErrorBar, ChartDataLabels);

export type ChartProps = {
  id: string;
  data: ChartData<'bar', DefaultDataPoint<'bar'>, string | undefined>;
  title?: string;
  colors?: string[];
  options?: ChartOptions<'bar'>;
  loading?: boolean;
  footer?: JSX.Element;
  sidebarLegend?: JSX.Element;
  filterSlot?: JSX.Element;
  isPreview?: boolean;
  chartTitle?: string;
  isUtilizationChart?: boolean;
};

export const BarChart: FC<ChartProps> = ({
  id,
  data,
  title,
  options = barChartOptions,
  filterSlot,
  footer,
  sidebarLegend,
  loading,
  isPreview,
  chartTitle,
  isUtilizationChart = false,
}) => {
  const hasData = data.datasets.filter(Boolean).reduce((acc, { data }) => acc + data.length, 0) > 0;

  // Utilization charts get their x axis order from the API response, when it is not provided
  // chart.js infers the categories from the datasets
  const dataWithLabels = { ...data, labels: data.labels?.length ? data.labels : [] };

  return (
    <ChartSkeleton
      id={id}
      loading={loading}
      isPreview={isPreview}
      isUtilizationChart={isUtilizationChart}
      chartTitle={chartTitle}
      title={
        <>
          {filterSlot && <FilterSlot>{filterSlot}</FilterSlot>}
          {title && <Title>{title}</Title>}
        </>
      }
      footer={hasData ? footer : undefined}
      sidebarLegend={ sidebarLegend }
    >
      {!hasData && <NoData />}
      {hasData && (
        <Bar
          plugins={[BGPlugin, DataPointsPlugin, ClickOnTickPlugin, CornerTitlePlugin]}
          options={options}
          data={isUtilizationChart ? dataWithLabels : data}
          height={100}
        />
      )}
    </ChartSkeleton>
  );
};
